"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var change_case_1 = require("change-case");
var reconnecting_websocket_1 = __importDefault(require("reconnecting-websocket"));
var config_1 = __importDefault(require("../config"));
var Store_1 = require("../models/Store");
var WebSocketConnection = /** @class */ (function () {
    function WebSocketConnection(token) {
        var _this = this;
        this.callbacks = [];
        console.log('[DEBUG][WebSocket] Connecting to', config_1.default.urls.ws);
        this.rws = new reconnecting_websocket_1.default("".concat(config_1.default.urls.ws, "?token=").concat(token));
        this.rws.addEventListener('open', function () {
            console.log('[DEBUG][WebSocket] Connected to', config_1.default.urls.ws);
        });
        this.rws.addEventListener('error', function (event) {
            console.log('[ERROR][WebSocket]', event.message, event.error);
        });
        this.rws.addEventListener('message', function (event) {
            var _a = JSON.parse(event.data), type = _a.type, payload = _a.payload;
            var fnName = (0, change_case_1.pascalCase)(type);
            console.log('[DEBUG][WebSocket] calling', fnName);
            var fn = _this["handle".concat(fnName)];
            if (fn) {
                fn.apply(_this, [payload]);
            }
        });
    }
    WebSocketConnection.prototype.close = function () {
        if (this.rws.readyState === reconnecting_websocket_1.default.OPEN) {
            this.rws.close();
        }
        console.log('[DEBUG][WebSocket] Connection to', config_1.default.urls.ws, 'is closed');
    };
    WebSocketConnection.prototype.registerCallback = function (callback) {
        this.callbacks.push(callback);
    };
    WebSocketConnection.prototype.handleLoadUpdate = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!Store_1.defaultRootStore.orderLegLinkId) return [3 /*break*/, 2];
                        return [4 /*yield*/, Store_1.defaultRootStore.fetchOrderLeg(payload.id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, Store_1.defaultRootStore.fetchLoadTableRows({ id__in: [payload.id] }, [])];
                    case 3:
                        _a.sent();
                        this.callbacks.forEach(function (callback) {
                            callback(payload);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WebSocketConnection.prototype.handleDriverScheduleUpdate = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Store_1.defaultRootStore.fetchDriverScheduleOrderLegs()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Store_1.defaultRootStore.fetchActiveDriverSchedule(true)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // private async handleManifestUpdate(payload: DriverScheduleData) {
    //   console.log('REQUEST PAYLOAD:', payload);
    //   await defaultRootStore.fetchManifest(payload.id);
    // }
    WebSocketConnection.prototype.handleLoadRemove = function (payloadId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Store_1.defaultRootStore.loads.delete("".concat(payloadId));
                return [2 /*return*/];
            });
        });
    };
    WebSocketConnection.prototype.handlePing = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log({ payload: payload });
                return [2 /*return*/];
            });
        });
    };
    WebSocketConnection.prototype.handleNotificationUpdate = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Store_1.defaultRootStore.fetchNotifications()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Store_1.defaultRootStore.fetchUnreadNotificationCount()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebSocketConnection.prototype.handleAdditionalBillingUpdate = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Store_1.defaultRootStore.fetchAdditionalBillingLeg(payload.id)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Store_1.defaultRootStore.fetchAdditionalBillingTableRows({
                                id__in: [payload.id],
                            }, [])];
                    case 2:
                        _a.sent();
                        this.callbacks.forEach(function (callback) {
                            callback(payload);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return WebSocketConnection;
}());
exports.default = WebSocketConnection;
